import { EmissorOrderScreenStatus } from '../types/emissor-order-history';
export const PENDING_PAYMENT_NOTICES_LIMIT = 5;
export const PENDING_PAYMENT_FETCH_LIMIT = 100;
export const PENDING_PAYMENT_EXPIRATION_DAYS = 15;
const DAY_IN_MS = 24 * 60 * 60 * 1000;
function parseCreatedAtMs(createdAt) {
    const parsed = Date.parse(createdAt);
    return Number.isNaN(parsed) ? Number.POSITIVE_INFINITY : parsed;
}
function getExpiryMs(createdAt) {
    return parseCreatedAtMs(createdAt) + PENDING_PAYMENT_EXPIRATION_DAYS * DAY_IN_MS;
}
export function isWithinPendingPaymentDeadline(createdAt, now = Date.now()) {
    return getExpiryMs(createdAt) >= now;
}
function comparePendingPaymentNotices(left, right) {
    const expiryDelta = getExpiryMs(left.createdAt) - getExpiryMs(right.createdAt);
    if (expiryDelta !== 0) {
        return expiryDelta;
    }
    const createdDelta = parseCreatedAtMs(left.createdAt) - parseCreatedAtMs(right.createdAt);
    if (createdDelta !== 0) {
        return createdDelta;
    }
    return left.protocol.localeCompare(right.protocol);
}
export function selectPendingPaymentNotices(orders) {
    return orders
        .filter(order => order.screenStatus === EmissorOrderScreenStatus.PENDING_PAYMENT &&
        isWithinPendingPaymentDeadline(order.createdAt))
        .sort(comparePendingPaymentNotices)
        .slice(0, PENDING_PAYMENT_NOTICES_LIMIT);
}
